import { Component, OnDestroy } from '@angular/core';
import { select, Store } from '@ngrx/store';
import { AppState } from '../../../../app.reducers';
import { Observable } from 'rxjs';
import { PropertyType } from '../../../property/shared/models';
import { ClearAdminPropertiesAction, ClearAdminPropertyCacheAction, DuplicateAdminPropertyAction, LoadAdminPortfoliosAction, LoadAdminPropertiesAction, ReassignAdminPropertyAction, ToggleAdminPropertyActiveStatusAction } from '../../admin-store';
import { getPropertyTypes } from '../../../property/property-store/property.selectors';
import { PropertySearchFilter, PropertySearchRequest } from '../../shared/models';
import { PropertySearchResult } from '../../shared/models/property-search-result';
import { PropertyFilterSettings } from '../../../shared/models/filter-settings';
import { getAdminPropertyFilterSettings, getAdminPropertySearchResult } from '../../admin-store/admin.selectors';
import { UserProfile } from 'app/internal/user/models';
import { getUserProfile } from 'app/internal/user/redux/user.selectors';

@Component({
  templateUrl: './admin-properties.component.html',
  styleUrls: ['./admin-properties.component.scss'],
  standalone: false
})

export class AdminPropertiesComponent implements OnDestroy {

  propertySearchResult$: Observable<PropertySearchResult>;
  propertyTypes$: Observable<PropertyType[]>;
  propertyFilterSettings$: Observable<PropertyFilterSettings>;
  loggedInUserProfile$: Observable<UserProfile>;

  filter: PropertySearchFilter;

  constructor(private store: Store<AppState>) {
    this.propertySearchResult$ = this.store.pipe(select(getAdminPropertySearchResult));
    this.propertyTypes$ = this.store.pipe(select(getPropertyTypes));
    this.propertyFilterSettings$ = this.store.pipe(select(getAdminPropertyFilterSettings));
    this.loggedInUserProfile$ = this.store.pipe(select(getUserProfile));
  }

  ngOnDestroy() {
    this.store.dispatch(new ClearAdminPropertiesAction());
  }

  onClearCache(propertyId: string) {
    this.store.dispatch(new ClearAdminPropertyCacheAction(propertyId));
  }

  onFilterChanged(filter: PropertySearchFilter) {
    this.filter = filter;
    const request = new PropertySearchRequest(filter);
    this.store.dispatch(new LoadAdminPropertiesAction(request));
    this.store.dispatch(new LoadAdminPortfoliosAction()); //Needed for the "Reassign Property" Modal functionality.
  }

  onDeactivateProperty(propertyId: string) {
    this.store.dispatch(new ToggleAdminPropertyActiveStatusAction({ propertyId: propertyId, isActive: false }));
  }

  onReactivateProperty(propertyId: string) {
    this.store.dispatch(new ToggleAdminPropertyActiveStatusAction({ propertyId: propertyId, isActive: true }));
  }

  onReassignProperty(data: any) {
    this.store.dispatch(new ReassignAdminPropertyAction({ propertyId: data.propertyId, destinationWorkspaceId: data.destinationWorkspaceId, includeUsers: data.includeUsers }));
  }

  onDuplicateProperty(propertyId: string) {
    this.store.dispatch(new DuplicateAdminPropertyAction({ propertyId: propertyId }));
  }
}
